<template>
  <v-card class="d-flex align-stretch mb-2" color="grey lighten-4" flat>
    <v-col cols="12">
      <v-card>
        <div class="d-flex">
          <v-col cols="10" lg="11">
            <v-card-title
              ><div               
              class="text-h6 primary--text">
                {{ documento.descricao }}
              </div>
            </v-card-title>
            <v-card-subtitle >              
              <div v-html="documento.instrucao" class="text-body-2 primary--text">                
              </div>
              <!-- Somente mostrado quando há modelo no tipo de documento -->
              <div class="text-body-2 indigo--text" v-if="documento.modelo">
                <a style="color: red"
                  :href="getLinkModelo(documento.modelo)"
                  download
                  >Formulário para download</a
                >
              </div>
            </v-card-subtitle>
          </v-col>
          <v-col
            cols="2"
            lg="1"
            align-self="center"
            class="d-flex justify-center"
          >
            <v-col
              class="d-flex align-center justify-center"
              @click="$refs.fileInput.click()"
            >
              <v-btn fab color="green darken-2" elevation="5">
                <v-icon color="white" large> mdi-plus </v-icon>
                <input
                  style="display: none"
                  type="file"
                  ref="fileInput"
                  @change="addFile"
                />
              </v-btn>
            </v-col>
          </v-col>
        </div>
        <v-divider></v-divider>
        <v-card-text>
          <v-list dense>
            <v-list-item
              v-for="arquivo in documento.arquivos"
              :key="arquivo.id"
              class="dense-list-item"
            >
              <v-list-item-avatar class="dense-list-item">
                <v-icon
                  small
                  :color="arquivo.avatar.color"
                  v-text="arquivo.avatar.icon"
                ></v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title
                  class="text-body-2"
                  v-text="arquivo.nome"
                ></v-list-item-title>
              </v-list-item-content>

              <v-list-item-action class="dense-list-item inline-itens">
                <v-btn
                  icon
                  color="blue darken-3"
                  title="Download"
                  @click="downloadArquivo(arquivo)"
                >
                  <v-icon>mdi-download</v-icon>
                </v-btn>

                <botao-excluir-com-confirmacao
                  @confirm="removeArquivo(arquivo)"
                  ctexto="Tem certeza que deseja excluir esse Arquivo?"
                ></botao-excluir-com-confirmacao>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-progress-linear
            :value="progress"
            :color="cor_progresso"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-col>
  </v-card>
</template>
<style scoped>
.dense-list-item {
  padding: 0px;
  margin: 0px !important;
  min-height: 0px;
}
.inline-itens {
  flex-direction: row;
}
</style>

<script>
import Uppy from "@uppy/core";
import Tus from "@uppy/tus";
import "@uppy/core/dist/style.css";
import "@uppy/file-input/dist/style.css";
import * as ArquivoService from "@/services/arquivo.service";
import Arquivo from "@/models/arquivo";

import authHeader from "@/services/api/api.auth.header";

const ptBR = require("@uppy/locales/lib/pt_BR");

const cor_nao_enviado = "blue-grey lighten-3";
const cor_enviado = "green darken-2";

export default {
  props: {
    documento: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      progress: 0,
      cor_progresso: cor_nao_enviado,
    };
  },
  mounted() {
    this.instantiateUppy();
    this.cor_progresso = this.documento.arquivo ? cor_enviado : cor_nao_enviado;
    this.progress = this.documento.arquivo ? 100 : 0;
  },
  methods: {
    instantiateUppy() {
      this.uppy = Uppy({
        debug: true,
        autoProceed: true,
        restrictions: {
          minNumberOfFiles: 1,
          maxNumberOfFiles: 50,
          allowedFileTypes: ["*/*"],
        },
        locale: ptBR,
      })
        .use(Tus, {
          endpoint:
            process.env.VUE_APP_API_BASEURL +
            "prematricula/documentos/" +
            this.documento.id +
            "/upload",
          headers: { Authorization: authHeader() },
          resume: true,
          autoRetry: true,
          limit: 10,
          removeFingerprintOnSuccess: true,
          retryDelays: [0, 1000, 3000, 5000],
        })
        .on("progress", (p) => {
          this.progress = p;
        })
        .on("upload-success", (file, response) => {
          var id = this.uploadID(response.uploadURL);
          this.cor_progresso = cor_enviado;
          this.documento.arquivos.push(new Arquivo(id, file.name));
          this.uppy.removeFile(file.id);
          this.$emit("alterouDocumento");
        });
    },
    uploadID(uploadURL) {
      return uploadURL.substring(uploadURL.length - 36);
    },
    addFile(event) {
      var arquivo = event.target.files[0];
      this.uppy.addFile({
        name: arquivo.name,
        type: arquivo.type,
        data: arquivo,
        source: "Local",
        isRemote: false,
      });
      this.$refs.fileInput.value = '';
    },
    removeArquivo(arquivo) {
      this.$nprogress.start();
      ArquivoService.rmvOne(arquivo.id)
        .then(() => {
          this.documento.arquivos.splice(
            this.documento.arquivos.indexOf(arquivo),
            1
          );
          this.$msg.warning("Arquivo removido!");
          this.$emit("alterouDocumento");
        })
        .finally(() => this.$nprogress.done());
    },
    downloadArquivo(arquivo) {
      ArquivoService.getOne(arquivo.id).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", arquivo.nome);
        document.body.appendChild(fileLink);

        fileLink.click();
      });
    },
    getLinkModelo(nome) {
      return "/files/" + nome;
    },
  },
};
</script>